import { HTMLAttributes, memo, useMemo } from 'react';
import { twMerge } from 'tailwind-merge';
import { processContentTables } from 'src/utils';
import './styles.css';

type Props = HTMLAttributes<HTMLDivElement> & {
  content: string | undefined;
};

const _CmsContent = ({ className, content }: Props) => {
  const preparedContent = useMemo(() => processContentTables(content), [content]);

  return (
    <div
      className={twMerge('cms-dropdown', className)}
      dangerouslySetInnerHTML={{ __html: preparedContent }}
    />
  );
};

export const CmsContent = memo(_CmsContent);
